export {
    getAbsoluteRoute,
    getContext,
    getExternalRoutes,
    getRouteCapabilities,
    getRouteChildren,
    getRouteConfig,
    getRouteInternalPath,
    isRouteParent,
    type RouteParentPath,
} from './routes'
export { getBreadcrumbConfig } from './breadcrumbs'
